import React from 'react';
import { Box } from '@mui/material';
import loadingImage from '../../../../assets/images/rescue-image-loading.jpg';

const GalleryGridItem = ({ tile, handleDialogOpen, children }) => (
  <Box
    onClick={handleDialogOpen}
    sx={{
      cursor: 'pointer',
      backgroundColor: '#a2a2a2',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      height: '100%',
      width: '100%',
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${tile.thumbnaillUrl}), url(${loadingImage})`,
        width: '100%',
        height: '100%',
      }}
    />
    {children}
  </Box>
);

export default GalleryGridItem;
